import { env } from './env';

interface Grecaptcha {
  ready: (callback: () => void) => void;
  execute: (siteKey: string, options: { action: string }) => Promise<string>;
}

declare global {
  interface Window {
    grecaptcha?: Grecaptcha;
  }
}

let loading: Promise<Grecaptcha> | null = null;

function load(siteKey: string) {
  loading ??= new Promise<Grecaptcha>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
    script.async = true;
    script.onload = () => window.grecaptcha?.ready(() => resolve(window.grecaptcha!));
    script.onerror = () => {
      loading = null;
      reject(new Error('reCAPTCHA could not load'));
    };
    document.head.appendChild(script);
  });
  return loading;
}

/**
 * A reCAPTCHA v3 token for one action ("provider_signup"), checked by the API. Without a site key (local
 * development) it is empty, and the API skips the check when it has no secret either. The script is only loaded
 * on pages that ask for a token.
 */
export async function recaptchaToken(action: string): Promise<string> {
  const siteKey = env.recaptchaSiteKey;
  if (!siteKey) return '';
  const grecaptcha = await load(siteKey);
  return grecaptcha.execute(siteKey, { action });
}
